import produce from 'immer'

const initialState = {
  hasUnpublishedChanges: false,
  publishInProgress: false,
  isPublishBlockedDueToUnconfirmedImages: false,
  isPublishBlockedDueToNoPropertyImages: false,
  failedToPublish: false,
  permissions: {},
}

const property = produce((draft = initialState, action) => {
  switch (action.type) {
    case 'PROPERTY_SET_UNPUBLISHED_CHANGES':
      draft.hasUnpublishedChanges = action.payload
      return draft
    case 'PROPERTY_SET_IS_PUBLISH_BLOCKED_UNCONFIRMED_IMAGES':
      draft.isPublishBlockedDueToUnconfirmedImages = action.payload
      return draft
    case 'PROPERTY_SET_IS_PUBLISH_BLOCKED_NO_PROPERTY_IMAGES':
      draft.isPublishBlockedDueToNoPropertyImages = action.payload
      return draft
    case 'PROPERTY_PUBLISH_IN_PROGRESS':
      draft.publishInProgress = action.payload
      return draft
    case 'PROPERTY_SET_FAILED_TO_PUBLISH':
      draft.failedToPublish = action.payload
      return draft
    case 'PROPERTY_SET_PERMISSIONS':
      draft.permissions = action.payload
      return draft
    default:
      return draft
  }
})

export default property
